import { z } from 'zod';

export const HEX_RGBA_COLOR_REGEX = /^#[0-9a-fA-F]{8}$/;

export const colorSchema = z.string().regex(HEX_RGBA_COLOR_REGEX, {
  message: 'Color must be a #RRGGBBAA string',
});
